import { createContext } from 'react';
var DialogContext = /*#__PURE__*/createContext(undefined);
var DialogHeadingContext = /*#__PURE__*/createContext(undefined);
var DialogDescriptionContext = /*#__PURE__*/createContext(undefined);
export { DialogContext as D, DialogHeadingContext as a, DialogDescriptionContext as b };